var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 153,
    viewBox: "0 0 155 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.495 141.347V133.2C147.495 113.919 131.807 98.374 112.517 98.374H42.485C23.1194 98.374 7.50684 113.994 7.50684 133.2V141.347",
    stroke: "#2B318A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.516 42.8821C112.516 62.1637 96.8283 77.7085 77.5378 77.7085C58.2472 77.7085 42.5596 62.0889 42.5596 42.8821C42.5596 23.6752 58.1722 8.05566 77.5378 8.05566C96.9034 8.05566 112.516 23.6752 112.516 42.8821Z",
    stroke: "#2B318A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPurple);
export default __webpack_public_path__ + "static/media/userPurple.68fd6f463e468065c982e8644f0e06b9.svg";
export { ForwardRef as ReactComponent };